<!-- <app-navbar-one></app-navbar-one> -->
<app-navbar-two></app-navbar-two>
<div class="page-title-area item-bg-1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Contact Us</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Contact Us</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="contact-box pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-box">
                    <i class="flaticon-pin"></i>
                    <div class="content-title">
                        <h3>Address</h3>
                        <p>Chandigarh, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-contact-box">
                    <i class="flaticon-envelope"></i>
                    <div class="content-title">
                        <h3>Email</h3>
                        <a href="mailto:contactus@alphurious.com">contactus@alphurious.com</a>
                        <!-- <a href="mailto:fax@avrax.com">fax@avrax.com</a> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="single-contact-box">
                    <i class="flaticon-phone-call"></i>
                    <div class="content-title">
                        <h3>Phone</h3>
                        <a href="tel:+91-6283068477">+91-6283068477</a>
                        <!-- <a href="tel:126446129">+126(446)129</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="contact-section pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="contact-text">
                    <h3>Have Any Questions About Us?</h3>
                    <p>If any type of query, kindly fill & submit below form </p>
                </div>
                <div class="contact-form">
                    <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit(contactUsForm)">
                       
                       <!-- Name -->
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" name="name" formControlName="name" class="form-control" placeholder="Name" maxlength="50">
                        </div>
                        <div class="error" *ngIf="(registerFormControl.name.touched || submitted) && registerFormControl.name.errors?.required">
                            The name is required.
                        </div>
                        <div class="error"  *ngIf="(registerFormControl.name.touched || submitted) && registerFormControl.name.errors?.maxlength">
                            Max 50 characters are allowed.
                        </div>

                        <!-- Email -->
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" name="email" formControlName="email" class="form-control" placeholder="Your Email">
                        </div>
                        <div class="error"  *ngIf="(registerFormControl.email.touched || submitted) && registerFormControl.email.errors?.required">
                            The email is required.
                        </div>
                        <div class="error"  *ngIf="registerFormControl.email.touched && registerFormControl.email.errors?.email">
                            Invalid email format.
                        </div>                        

                        <!-- Subject -->
                        <div class="form-group">
                            <label>Subject</label>
                            <input type="text" name="msg_subject" formControlName="subject" class="form-control" placeholder="Your Subject" maxlength="200">
                        </div>
                        <div class="error" *ngIf="(registerFormControl.subject.touched || submitted) && registerFormControl.subject.errors?.required">
                            The subject is required.
                        </div>
                        <div class="error" *ngIf="(registerFormControl.subject.touched || submitted) && registerFormControl.subject.errors?.maxlength">
                            Max 200 characters are allowed.
                        </div>

                        <!-- Message -->
                        <div class="form-group">
                            <label>Message</label>
                            <textarea name="message" class="form-control" formControlName="message" cols="30" rows="6" placeholder="Your Message" maxlength="1000"></textarea>
                        </div>
                        <div class="error" *ngIf="(registerFormControl.message.touched || submitted) && registerFormControl.message.errors?.required">
                            The message is required.
                        </div>
                        <div class="error" *ngIf="(registerFormControl.message.touched || submitted) && registerFormControl.message.errors?.maxlength">
                            Max 1000 characters are allowed.
                        </div>
                        <div class="send-btn">
                            <button type="submit" class="default-btn" [disabled]="!contactUsForm.valid">Send Message</button>
                        </div>

                        <div *ngIf="successMessage" class="success_div">
                            {{successMessage}}
                        </div>

                        <div *ngIf="errorMessage" class="error_div">
                            {{errorMessage}}
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-image">
                    <img src="assets/img/contact.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>